import React from "react";
import { createPortal } from "react-dom";
import { FieldDetailCardBody } from "../FieldDetailCardBody";
import { FieldDetailCardHeader } from "../FieldDetailCardHeader";
import { Card } from "./FieldDetailCard.styles";
import type { FieldDetailCardProps } from "./FieldDetailCard.types";

/**
 * Field hover card, portalled to `document.body` so the Data models panel's
 * scroll container never clips it. Purely presentational: where it sits and
 * when it opens are the caller's decisions.
 */
export const FieldDetailCard: React.FC<FieldDetailCardProps> = ({
  detail,
  bodyState,
  rect,
  ids,
  cardRef,
  onRetry,
  onMouseEnter,
  onMouseLeave,
  className,
}) =>
  createPortal(
    <Card
      ref={cardRef}
      id={ids.card}
      role="dialog"
      aria-modal="false"
      aria-labelledby={ids.title}
      data-testid="field-detail-card"
      className={className}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ top: rect.top, left: rect.left, width: rect.width, maxHeight: rect.maxHeight }}
    >
      <FieldDetailCardHeader
        label={detail.label}
        kind={detail.kind}
        chips={detail.chips}
        titleId={ids.title}
      />
      {bodyState && (
        <FieldDetailCardBody
          state={bodyState}
          onRetry={onRetry}
          completenessLabelId={ids.completenessLabel}
        />
      )}
    </Card>,
    document.body,
  );

export default FieldDetailCard;
